import React, {
  ChangeEvent,
  DragEvent,
  useEffect,
  useRef,
  useState,
} from 'react'
import { useCookies } from 'react-cookie'
import ReCAPTCHA from 'react-google-recaptcha'
import { serialize } from 'object-to-formdata'
import { navigate } from 'gatsby'
import { Head, Menubar } from '@components'
import InputMask from 'react-input-mask'
import cn from 'classnames'
import axios from 'axios'
import * as st from '@assets/styl/contact.module.styl'
import arrowDown from '@assets/svg/select-arrow-down.svg'
import arrowUp from '@assets/svg/select-arrow-up.svg'
import { Link, animateScroll as scroll } from 'react-scroll'
import { useLanguage } from '../../hooks'
import { t } from 'i18next'
import { translatePath } from '../../translations'
import { StaticImage } from 'gatsby-plugin-image'

const onSubmit = (
  data: any,
  loadingHandler: () => void,
  successHandler: () => void
) => {
  loadingHandler()
  axios
    .post(
      'https://admin.dimasconstrucoes.com.br/api/page-curriculum',
      serialize(data)
    )
    .then((res) => {
      loadingHandler()
      res.data?.message === 'OK' && navigate('/sucesso/')
      successHandler()
    })
}

interface FileProps {
  accept: string
  id: string
  value: File
  onChange: (file: File) => void
}

const File = ({ accept, id, value, onChange }: FileProps) => {
  const onChangeFile = (e: ChangeEvent<HTMLInputElement>, file?: File) => {
    if (!file && e?.target.files.length === 0) return
    onChange(file || e?.target.files?.[0])
  }
  const dragEvents = {
    onDragOver: (e: DragEvent) => {
      e.preventDefault()
      e.stopPropagation()
    },
    onDrop: (e: DragEvent) => {
      e.preventDefault()
      e.stopPropagation()
      if (
        e.dataTransfer.files &&
        e.dataTransfer.files.length > 0 &&
        accept.includes(e.dataTransfer.files[0].type)
      )
        onChangeFile(null, e.dataTransfer.files[0])
    },
  }
  const { t } = useLanguage()
  return (
    <div className={st.file} {...dragEvents}>
      <button
        onClick={(e) => {
          e.preventDefault()
          document.getElementById(id).click()
        }}
        {...dragEvents}
      >
        {t('WorkWithUs.choiceFile')}
      </button>
      <input
        type="text"
        placeholder={t('WorkWithUs.form.noneFile')}
        value={(value as File)?.name || ''}
        disabled
        {...dragEvents}
      />
      {value && (
        <button
          onClick={(e) => {
            e.preventDefault()
            onChangeFile(null)
          }}
          className={st.remove}
          {...dragEvents}
        ></button>
      )}
      <input
        type="file"
        id={id}
        required={!value}
        onChange={onChangeFile}
        accept={accept}
        key={value?.name || ''}
      />
    </div>
  )
}

const Accordion = ({ areas, setData, data, setActiveSelect }) => {
  const [isActive, setIsActive] = useState<string | number>()

  const handleAcc = (number: number) => {
    return isActive == number ? setIsActive(null) : setIsActive(number)
  }

  const { t } = useLanguage()

  return (
    <ul>
      {areas.map(({ id, title, description }) => (
        <li
          key={id}
          className={cn(st.accordionItem)}
          onClick={() => handleAcc(id)}
        >
          {title}
          <img
            src={isActive === id ? arrowUp : arrowDown}
            alt="Arros"
            width={12}
            height={12}
          ></img>
          <div
            className={cn(
              st.accordionContent,
              isActive === id ? st.activeDescription : undefined
            )}
          >
            <div
              dangerouslySetInnerHTML={{ __html: description }}
              className={st.containerDescription}
            ></div>
            <button className="btn">
              <Link
                onClick={() => {
                  if (data.type === '') {
                    data.type = 'Vagas'
                  }
                  setData({ ...data, area: title })
                  setActiveSelect(true)
                }}
                to="form"
                smooth={true}
                offset={-150}
                duration={500}
                isDynamic={true}
              >
                {t('WorkWithUs.register')}
              </Link>
            </button>
          </div>
        </li>
      ))}
    </ul>
  )
}

const WorkWithUs = () => {
  const [cookies] = useCookies()
  const recaptchaRef = useRef<ReCAPTCHA>()

  const [submitLabel, setSubmitLabel] = useState(t('WorkWithUs.send'))

  const [activeSelect, setActiveSelect] = useState(false)
  const [activeSelectTalents, setActiveSelectTalents] = useState(false)

  const talents = [
    {
      name: t('WorkWithUs.talents.1'),
    },
    {
      name: t('WorkWithUs.talents.2'),
    },
    {
      name: t('WorkWithUs.talents.3'),
    },
    {
      name: t('WorkWithUs.talents.4'),
    },
    {
      name: t('WorkWithUs.talents.5'),
    },
    {
      name: t('WorkWithUs.talents.6'),
    },
    {
      name: t('WorkWithUs.talents.7'),
    },
    {
      name: t('WorkWithUs.talents.8'),
    },
    {
      name: t('WorkWithUs.talents.9'),
    },
    {
      name: t('WorkWithUs.talents.10'),
    },
    {
      name: t('WorkWithUs.talents.11'),
    },
    {
      name: t('WorkWithUs.talents.12'),
    },
    {
      name: t('WorkWithUs.talents.13'),
    },
    {
      name: t('WorkWithUs.talents.14'),
    },
    {
      name: t('WorkWithUs.talents.15'),
    },
    {
      name: t('WorkWithUs.talents.16'),
    },
  ]

  const defaultData = {
    name: '',
    email: '',
    phone: '',
    area: '',
    type: '',
    file: null,
    privacy: false,
    utmz: cookies?.['__trf.src'] || cookies?.__utmzz,
  }
  const [data, setData] = useState({ ...defaultData })
  const [areas, setAreas] = useState<
    Array<{ id: number; title: string; description: string }>
  >([])

  useEffect(() => {
    axios
      .get('https://admin.dimasconstrucoes.com.br/api/jobs')
      .then(({ data }) => setAreas(data.result))
  }, [])

  const handleSelectClick = (value: string) => {
    value === 'Vagas' ? setActiveSelect(true) : setActiveSelect(false)
  }

  return (
    <>
      <Head
        pathname={translatePath('/contato/trabalhe-conosco/')}
        basePath="/contato/trabalhe-conosco/"
        title={t('WorkWithUs.titlePage')}
        description={t('WorkWithUs.descriptionPage')}
      />

      <Menubar pathname="/contato/trabalhe-conosco/" position="absolute" />

      <section className={cn(st.hero, st.workWithUsHero, 'heroScroll')}>
        <h1>
          {t('WorkWithUs.title.1')} <b>{t('WorkWithUs.title.2')}</b>
        </h1>
        <div className={st.bg}>
          <StaticImage
            src="../../assets/img/trabalhe-conosco.jpg"
            alt=""
            className={st.desktop}
            loading="lazy"
          />
          <StaticImage
            src="../../assets/img/trabalhe-conosco-mobile.jpg"
            alt=""
            className={st.mobile}
            loading="lazy"
          />
        </div>
      </section>

      {areas.length > 0 && (
        <section className={st.formWrapper}>
          <h2 className={st.workSubtitle}>{t('WorkWithUs.subtitle')}</h2>
          <div className={cn(st.availableRolesContainer)}>
            <p className={st.availableVacancies}>
              {t('WorkWithUs.availableVacancies')}
            </p>
            <Accordion
              areas={areas}
              setData={setData}
              data={data}
              setActiveSelect={setActiveSelect}
            />
          </div>
        </section>
      )}

      <section className={cn(st.formWrapper, st.workWithUs)} id="form">
        <div>
          <h2 className={st.partTeam}>{t('WorkWithUs.partTheTeam')}</h2>
          <p className={st.partTeamText}>{t('WorkWithUs.useTheForm')}</p>
          <form
            onSubmit={(e) => {
              e.preventDefault()
              recaptchaRef.current.executeAsync().then((recaptcha) => {
                onSubmit(
                  { recaptcha, ...data },
                  () =>
                    setSubmitLabel(
                      submitLabel !== 'Enviar mensagem'
                        ? 'Enviar mensagem'
                        : 'Carregando'
                    ),
                  () => setData({ ...defaultData })
                )
                recaptchaRef.current?.reset()
              })
            }}
          >
            <div className={st.medium}>
              <label htmlFor="nome">{t('WorkWithUs.form.name')}</label>
              <input
                type="text"
                id="nome"
                value={data.name}
                onChange={(e) => setData({ ...data, name: e.target.value })}
                required
              />
            </div>
            <div className={st.medium}>
              <label htmlFor="email">{t('WorkWithUs.form.email')}</label>
              <input
                type="email"
                id="email"
                value={data.email}
                onChange={(e) => setData({ ...data, email: e.target.value })}
                required
              />
            </div>
            <div>
              <label htmlFor="celular">{t('WorkWithUs.form.phone')}</label>
              <InputMask
                mask={
                  data.phone.length > 14 ? '(99) 99999-9999' : '(99) 9999-99999'
                }
                maskChar={null}
                type="tel"
                id="celular"
                placeholder={t('WorkWithUs.form.placeholderPhone')}
                value={data.phone}
                onChange={(e) => setData({ ...data, phone: e.target.value })}
                required
                pattern=".{14,15}"
              />
            </div>
            <div>
              <label htmlFor="interesse">
                {t('WorkWithUs.form.interestIn')}
              </label>
              <select
                id="interesse"
                value={data.type}
                onClick={() => {
                  if (data.type === 'Banco de talentos') {
                    setActiveSelectTalents(true)
                  } else {
                    setActiveSelectTalents(false)
                  }
                }}
                onChange={(e) => {
                  setData({
                    ...data,
                    type: e.target.value,
                  })
                  handleSelectClick(e.target.value)
                }}
                required
              >
                <option disabled hidden value="">
                  {t('WorkWithUs.form.select')}
                </option>

                <option value="Vagas">{t('WorkWithUs.form.vacancys')}</option>
                <option value="Banco de talentos">
                  {t('WorkWithUs.form.talentPool')}
                </option>
              </select>
            </div>
            <div className={cn({ [st.hidden]: !activeSelectTalents })}>
              <label htmlFor="Área de interesse">
                {t('WorkWithUs.form.areaOfInterest')}
              </label>
              <select
                id="Área de interesse"
                value={data.area}
                onChange={(e) => {
                  setData({
                    ...data,
                    area: e.target.value,
                  })
                }}
                required={activeSelectTalents === false ? false : true}
              >
                <option value="">{t('WorkWithUs.form.select')}</option>

                {talents.map(({ name }, key) => (
                  <option key={key} value={name}>
                    {name}
                  </option>
                ))}
              </select>
            </div>
            <div className={cn({ [st.hidden]: !activeSelect })}>
              <label htmlFor="vagas">Vagas</label>
              <select
                id="vagas"
                value={data.area}
                onChange={(e) =>
                  setData({
                    ...data,
                    area: e.target.value,
                  })
                }
                required={activeSelect === false ? false : true}
              >
                <option value="">{t('WorkWithUs.form.select')}</option>
                {areas.map(({ id, title }) => (
                  <option key={id}>{title}</option>
                ))}
              </select>
            </div>

            <div className={st.medium}>
              <label htmlFor="curriculo">
                {t('WorkWithUs.form.attachYourResume')}
              </label>
              <File
                accept="application/pdf"
                id="curriculo"
                value={data.file}
                onChange={(file) => setData({ ...data, file })}
              />
            </div>
            <p className={st.wide}>
              {t('WorkWithUs.paragraph.1')}
              <br />
              {t('WorkWithUs.paragraph.2')}
            </p>
            <div className={cn(st.checkbox, st.wide)}>
              <div className={cn(data.privacy && st.checked)}>
                <input
                  type="checkbox"
                  id="permissao"
                  checked={data.privacy}
                  onChange={(e) =>
                    setData({ ...data, privacy: e.target.checked })
                  }
                  required
                />
              </div>
              <label htmlFor="permissao">
                <p>
                  {t('WorkWithUs.terms.1')}{' '}
                  <a
                    target="_blank"
                    href="https://www.dimasconstrucoes.com.br/politica-de-privacidade/"
                  >
                    {t('WorkWithUs.terms.2')}
                  </a>{' '}
                  {t('WorkWithUs.terms.3')}{' '}
                  <a
                    target="_blank"
                    href="https://www.dimasconstrucoes.com.br/termos-de-uso/"
                  >
                    {t('WorkWithUs.terms.4')}
                  </a>
                  .
                </p>
              </label>
            </div>
            <div className={st.wide}>
              <ReCAPTCHA
                ref={recaptchaRef}
                sitekey="6LeDttIjAAAAAITCV0-iCbP5f594MO0sP9pjsbl-"
                size="invisible"
              />
              <button className="btn">{submitLabel}</button>
            </div>
          </form>
        </div>
      </section>
    </>
  )
}

export default WorkWithUs
